/**
 * Honest large-board notice (monday.com-style): shown when a board has loaded
 * the safety cap of rows, so the user knows the list is bounded and how to see
 * the rest. Owns the threshold check so every board surface and every view
 * stays honest about the same bound.
 */
import { useTranslation } from 'react-i18next';

interface BoardCapNoticeProps {
  /** Rows the board holds in memory, before any client-side filtering. */
  total: number;
  cap: number;
}

export function BoardCapNotice({ total, cap }: BoardCapNoticeProps) {
  const { t } = useTranslation('trackers');

  if (total < cap) return null;

  return (
    <div className="mx-4 mb-2 rounded-md border border-border bg-muted px-3 py-2 text-xs text-muted-foreground">
      {/* Pinned rather than left to the browser: the copy around it is English, so a
          visitor on a pt-BR machine would otherwise read "1.500" in an English sentence. */}
      {t('trackersBoard.boardCapNotice.showingTheFirstItems', {
        cap: cap.toLocaleString('en-US'),
      })}
    </div>
  );
}
